import { i18n } from '@/locales';
const lc = 'views.operation_setting.';
export const hubListHeader = [
    {
        title: i18n.t(`${lc}hub_name`),
        value: 'name',
        align: 'start',
        sortable: false,
    },
    {
        title: i18n.t(`${lc}apply_config_surcharge`),
        value: 'formattedAddChargeApplyYn',
        align: 'center',
        sortable: false,
        width: 90,
    },
    {
        title: i18n.t(`${lc}irregular_surcharge_with_sign`),
        value: 'formattedAddDeliveryChargeAndRate',
        align: 'center',
        sortable: false,
        width: 137,
    },
    {
        title: i18n.t(`${lc}delivery_status`),
        value: 'getFulfillmentStateToText',
        align: 'center',
        sortable: false,
        width: 100,
    },
];
export const storeListHeader = [
    {
        title: i18n.t(`${lc}store_name`),
        value: 'name',
        align: 'start',
        sortable: false,
    },
    {
        title: i18n.t(`${lc}apply_config_surcharge`),
        value: 'formattedAddChargeApplyYn',
        align: 'center',
        sortable: false,
        width: 90,
    },
    {
        title: i18n.t(`${lc}irregular_surcharge_with_sign`),
        value: 'formattedAddDeliveryChargeAndRate',
        align: 'center',
        sortable: false,
        width: 137,
    },
    {
        title: i18n.t(`${lc}delivery_status`),
        value: 'getFulfillmentStateToText',
        align: 'center',
        sortable: false,
        width: 100,
    },
];
